import React, { FC, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Button } from '@mui/material';
import ROUTE_PATHS from 'routes/values';
import ErrorsViewWrapper, { ErrorsViewContent } from './Errors.styled';
import { ReactComponent as Image } from './assets/baby.svg';

const ErrorsView: FC = (): JSX.Element => {
  const seg = 30;
  const { t: translation } = useTranslation();
  const [timer, setTimer] = useState<number>(seg);

  const handleOnClickRedirect = (): void => {
    window.location.href = ROUTE_PATHS.ROOT;
  };

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (timer > 0) {
      const timerId = setTimeout(() => {
        setTimer(timer - 1);
      }, 1000);
      return () => clearTimeout(timerId); // Limpiar el timeout en cada render
    }
  }, [timer]);

  useMemo(() => {
    if (timer <= 0) {
      handleOnClickRedirect();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timer]);

  // const interval = setInterval(() => {
  //   const t = timer - 1;
  //   setTimer(t);
  // }, 1000);

  // useEffect(
  //   () => () => {
  //     clearInterval(interval);
  //   },
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  //   [],
  // );

  return (
    <ErrorsViewWrapper data-testid="ErrorsView">
      <ErrorsViewContent className="error-page-content">
        <Image className="svgBaby" />

        <Typography variant="subtitle2" component="h2" sx={{ mt: 10 }}>
          {translation('common:ERRORS.TEXT', { seg: timer })}
          <Button
            sx={{
              display: 'inline-block',
            }}
            onClick={handleOnClickRedirect}
          >
            {translation('common:ERRORS.REFRESH', { seg: timer })}
          </Button>
        </Typography>
        {/* <Link onClick={console.info}>{translation('common:ERRORS.REFRESH', { seg: timer })}</Link> */}
        {/* <Box
            sx={{
              display: 'block',
            }}
          >
            <Box sx={{ position: 'relative', display: 'inline-flex', margin: '20px auto' }}>
              <CircularProgress variant="determinate" size={80} value={(100 / seg) * timer} />
              <Box
                sx={{
                  top: 0,
                  left: 0,
                  bottom: 0,
                  right: 0,
                  position: 'absolute',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Typography
                  variant="subtitle2"
                  // color={(theme) => theme.palette.primary.main}
                  component="div"
                  sx={{ textAlign: 'center', width: 30 }}
                >
                  {`${timer}s.`}
                </Typography>
              </Box>
            </Box>
          </Box> */}
      </ErrorsViewContent>
    </ErrorsViewWrapper>
  );
};

export default ErrorsView;
